import React from 'react';
import {Navigate} from 'react-router-dom';
import * as consts from '../../utils/constants';
import {getQueryParam} from '../../utils/helpers';

function NavigateHomeFeature() {
  const backUrl = getQueryParam('back_url');
  return <Navigate to={backUrl || consts.SLUG_HOME} />;
}

export default NavigateHomeFeature;
